import React, { useEffect, useMemo, useState } from "react";
import { Info, RotateCw } from "lucide-react";
import "../parametresStyles/WorkflowManagement.css";
import { useDispatch, useSelector } from "react-redux";

import {
    saveWorkflowLevelsRequest,getWorkflowLevelsRequest
} from "../../../../redux/actions/workflowValidationActions";

const REQUESTS = [
    {
        id: "attestation_travail",
        title: "Demande d'attestation de travail",
        description: "Validation des demandes d'attestations de travail",
    },
    {
        id: "conge",
        title: "Demande de congé",
        description: "Validation des demandes de congés annuels, maladie, etc.",
    },
    {
        id: "feuille_temps",
        title: "Feuille de temps",
        description: "Validation des feuilles de temps hebdomadaires/mensuelles",
    },
    {
        id: "pret",
        title: "Demande de prêt / Avance sur salaire",
        description: "Validation des demandes de prêt et avances sur salaire",
    },
    {
        id: "note_frais",
        title: "Note de frais",
        description: "Validation des notes de frais et remboursements",
    },
];

export default function WorkflowManagement() {
    const dispatch = useDispatch();

    // ✅ Redux state
    const loading = useSelector((state) => state.workflowValidation?.loading);
    const levelsFromStore = useSelector((state) => state.workflowValidation?.levels || {});
    const error = useSelector((state) => state.workflowValidation?.error);

    // ✅ Local state (UI)
    const [levels, setLevels] = useState({});

    // ✅ sync store -> local
    useEffect(() => {
        setLevels(levelsFromStore || {});
    }, [levelsFromStore]);

    // ✅ fetch on mount
    useEffect(() => {
        dispatch(getWorkflowLevelsRequest());
    }, [dispatch]);

    const isFormValid = useMemo(
        () => REQUESTS.every((r) => !!levels[r.id]),
        [levels]
    );

    const handleRefresh = () => {
        dispatch(getWorkflowLevelsRequest());
    };

    const handleChange = (requestId, value) => {
        setLevels((prev) => ({ ...prev, [requestId]: value }));
    };

    const handleSave = () => {
        dispatch(saveWorkflowLevelsRequest(levels));
    };

    return (
        <div className="wfOld">
            {/* HEADER */}
            <div className="wfOld__header">
                <div className="wfOld__headerLeft">
                    <h1>Configuration des Workflows de Validation</h1>
                    <p>Définissez qui doit valider chaque type de demande dans votre organisation</p>

                    {/* optionnel: afficher l’erreur simple */}
                    {error ? <div className="wfOld__error">{error}</div> : null}
                </div>

                <button
                    type="button"
                    className="wfOld__refreshBtn"
                    onClick={handleRefresh}
                    disabled={!!loading}
                    aria-label="Rafraîchir"
                    title="Rafraîchir"
                >
                    <RotateCw size={18} />
                </button>
            </div>

            {/* LIST */}
            <div className="wfOld__list">
                {REQUESTS.map((req) => {
                    const selected = levels[req.id] || "";
                    return (
                        <div className="wfOld__card" key={req.id}>
                            <div className="wfOld__cardTitleRow">
                                <div className="wfOld__cardTitle">{req.title}</div>

                                <span className="wfOld__infoIcon" title={req.description}>
                  <Info size={14} />
                </span>
                            </div>

                            <div className="wfOld__cardDesc">{req.description}</div>

                            <div className="wfOld__radios" role="radiogroup" aria-label={req.title}>
                                <label className="wfOld__radio wfOld__radio--manager">
                                    <input
                                        type="radio"
                                        name={req.id}
                                        value="manager"
                                        checked={selected === "manager"}
                                        onChange={() => handleChange(req.id, "manager")}
                                        disabled={!!loading}
                                    />
                                    <span className="wfOld__dot" aria-hidden="true" />
                                    <span className="wfOld__label">Manager</span>
                                </label>

                                <label className="wfOld__radio wfOld__radio--admin">
                                    <input
                                        type="radio"
                                        name={req.id}
                                        value="admin"
                                        checked={selected === "admin"}
                                        onChange={() => handleChange(req.id, "admin")}
                                        disabled={!!loading}
                                    />
                                    <span className="wfOld__dot" aria-hidden="true" />
                                    <span className="wfOld__label">Responsable RH</span>
                                </label>

                                <label className="wfOld__radio wfOld__radio--both">
                                    <input
                                        type="radio"
                                        name={req.id}
                                        value="both"
                                        checked={selected === "both"}
                                        onChange={() => handleChange(req.id, "both")}
                                        disabled={!!loading}
                                    />
                                    <span className="wfOld__dot" aria-hidden="true" />
                                    <span className="wfOld__label">Les deux</span>
                                </label>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* FOOTER */}
            <div className="wfOld__footer">
                <button
                    type="button"
                    className="wfOld__saveBtn"
                    onClick={handleSave}
                    disabled={!!loading || !isFormValid}
                >
                    Enregistrer les modifications
                </button>
            </div>
        </div>
    );
}
